import React from "react";
import { SectionContentProps } from "../../types";
import StandardHeader from "./StandardHeader";
import CenteredHeader from "./CenteredHeader";
import { UniversityHeader } from "../../university";
import SplitHeader from "./SplitHeader";
import MinimalHeader from "./MinimalHeader";
import { HokHeader } from "../../hok";
import OvanHeader from "../../ovan/ovanheader/OvanHeader";
import { CollegeHeader } from "../../college";
import { SaasHeader } from "../../saas";
import { CorporateHeader } from "../../corporate";
import { AIHeader } from "../../aistartup";
import { PortfolioHeader } from "../../portfolio";

export default function HeaderSection(props: SectionContentProps) {
    const { content } = props;
    if (content.variant === "educaeet" || content.variant === "none" || content.hideHeader) {
        return null;
    }
    const isUniversity = content.variant === "university";
    const isV2 = content.variant === "v2" || content.variant === "header-v2";
    const isV3 = content.variant === "v3" || content.variant === "header-v3";
    const isV4 = content.variant === "v4" || content.variant === "header-v4";
    const isHok = content.variant === "hok" || content.variant === "header-hok";
    const isOvan = content.variant === "ovan";
    
    if (content.variant === "college") {
        return <CollegeHeader {...props} />;
    }
    if (content.variant === "saas") {
        return <SaasHeader {...props} />;
    }
    if (content.variant === "corporate") {
        return <CorporateHeader {...props} />;
    }
    if (content.variant === "aistartup") {
        return <AIHeader {...props} />;
    }
    if (content.variant === "portfolio") {
        return <PortfolioHeader {...props} />;
    }

    if (isUniversity) {
        return <UniversityHeader {...props} />;
    }

    if (isV2) {
        return <CenteredHeader {...props} />;
    }

    if (isV3) {
        return <SplitHeader {...props} />;
    }

    if (isV4) {
        return <MinimalHeader {...props} />;
    }

    if (isHok) {
        return <HokHeader {...props} />;
    }

    if (isOvan) {
        return <OvanHeader {...props} />;
    }

    return <StandardHeader {...props} />;
}

